import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    logged_in: true,
    is_loading: false,
    popup: {
      open: false,
      content: ''
    },
    cartOpen: false,
    toast: {
      open: false,
      message: ''
    },
    cart: []
  },
  mutations: {
    toggleCartSlider(state) {
      state.cartOpen = !state.cartOpen
    },
    setToast(state, data) {
      state.toast = data
    },
    setCart(state, data) {
      state.cart = data
    },
    setLoading(state, boolean) {
      state.is_loading = boolean
    }
  },
  getters: {},
  actions: {
    toast({ commit }, message) {
      commit('setToast', {
        open: true,
        message
      })

      setTimeout(
        () =>
          commit('setToast', {
            open: false,
            message: ''
          }),
        3000
      )
    }
  }
})



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/store.js